import React from 'react';
import PropTypes from 'prop-types';

const CurrentTimeLine = ({ timelinePosition, height, theme }) => (
    <div
        style={{
            zIndex: 99,
            position: 'absolute',
            top: 0,
            left: timelinePosition,
            height,
            ...theme,
        }}
        pointerEvents="none"
    />
);

CurrentTimeLine.propTypes = {
    height: PropTypes.number,
    timelinePosition: PropTypes.number,
    theme: PropTypes.object,
};

CurrentTimeLine.defaultProps = {
    height: 0,
    timelinePosition: PropTypes.number,
    theme: {},
};


export default CurrentTimeLine;
